import { Injectable } from '@angular/core';
import { decryptStorageValue, encryptStorageValue, purgeLegacyEntries, toStorageKey } from './storage-crypto';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() {
    purgeLegacyEntries(sessionStorage);
  }

  setItem(key: string, value: any) {
    sessionStorage.setItem(toStorageKey(key), encryptStorageValue(value));
  }

  getItem(key: string): any {
    return decryptStorageValue(sessionStorage.getItem(toStorageKey(key)));
  }
}
